export const emailInboxEn = {
  email_to_dost: "Email to Dost",
  send_or_forward_any_document_to_this_email_and_it_will_automatically_appear_in_dost_portal:
    "Send or forward any document to this email and it will automatically appear in Dost Portal.",
  pro_tip: "Pro Tip",
  pro_tip_text:
    "Set up an email forward rule in your inbox so any email from a customer containing an attachment is automatically forwarded here. Documents land in Dost with zero manual steps.",
  visit_dost_academy_for_tutorial: "Visit Dost Academy for tutorial",
  view_received_emails: "View Received Emails",
};
